// extracted by mini-css-extract-plugin
module.exports = {"LineChartSection":"EditIpPage_LineChartSection__XKCK4"};